import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../../api'
import Responsive from '../../../../assets/config/Responsive'
import PetIcon from '../../../../assets/icons/JSX/PetIcon'
import PetSmallIcon from '../../../../assets/icons/JSX/PetSmallIcon'
import Colors from '../../../../assets/styles/Colors'
import Accordion from '../../../../components/Accordion'
import DownloadButton from '../../../../components/DownloadButton'
import Loader from '../../../../components/Loader'
import NotFound404 from '../../../../components/NotFound404'
import PaymentSchedule from '../../../../components/PaymentSchedule'
import { PetPolicyDetailTypes, ScheduleType, currencySymbol, georgianFormatter } from '../../../../domain/types'
import { useAppSelector } from '../../../../store'
import DoubleRightIcon from '../../../../assets/icons/JSX/DoubleRightIcon'
import { toast } from 'react-toastify'
import PendingPayModal from '../../../../components/modals/PendingPayModal'
import DeleteModal from '../../../../components/modals/DeleteModal'
import FailIcon from '../../../../assets/icons/JSX/FailIcon'
import Button from '../../../../components/v2/buttons/Button'
import PendingPayments from '../../payment/PendingPayments'
import PayButton from '../../../../components/PayButton'
import TrashButton from '../../../../components/TrashButton'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { AppState } from '../../../../store/appSlice'

const PetPolicyDetail = () => {
  const { t } = useTranslation()
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const { policyId: policyIdStr = '0' } = useParams()
  const policyIdToNumber = parseInt(policyIdStr)

  const [activeTab, setActiveTab] = React.useState('1')
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue)
  }

  const {
    data: policyDetailData,
    isFetching: isPolicyDetailLoading,
    refetch: policyDetailRefetch,
  } = api.useGetUserCurrentPoliciesQuery(policyIdToNumber)

  const policyDetail = policyDetailData as unknown as PetPolicyDetailTypes

  const orderId = policyDetail?.mainPolicy?.orderItems?.[0]?.orderId

  const discount = policyDetail?.mainPolicy?.orderItems?.[0]?.order?.discount

  const { data: paymentScheduleData, isLoading: isPaymentScheduleDataLoading } = api.useGetPetPaymentScheduleQuery(
    {
      orderId,
    },
    {
      skip: orderId ? false : true,
    },
  )

  const { data: paymentTransactions, isLoading: isPaymentTransactionLoading } = api.useGetPetTransactionsQuery(
    {
      orderId,
    },
    {
      skip: orderId ? false : true,
    },
  )
  //
  const { data: paymentMethods, isLoading: isPaymentMethodsLoading } = api.useGetTplPaymentMethodsQuery(undefined)
  //
  const downloadPdf = (event: Event, url?: string) => {
    event?.stopPropagation()
    if (url) {
      const fileName = url?.split('frani.com/')?.[1] || 'file name not found'
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/pdf',
        },
      })
        .then((response) => {
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
          saveAs(pdfBlob, fileName)
        })
        .catch((error) => {
          toast.error('ფაილის ჩამოტვირთვისას მოხდა შეცდომა:', error)
        })
    }
  }
  //
  //
  const start = dayjs(policyDetail?.mainPolicy?.startDate)
  const end = dayjs(policyDetail?.mainPolicy?.endDate)
  const diffInDays = end.diff(start, 'day')
  //
  //
  const _scheduleArray = () => {
    //
    if (paymentScheduleData) {
      //
      const formatedData: ScheduleType = {
        nextPaymentAmount: georgianFormatter.format(paymentScheduleData.nextPaymentAmount),
        totalPaymentAmount: georgianFormatter.format(paymentScheduleData.totalRemainedPaymentAmount),
        nextPaymentDate: paymentScheduleData.nextPaymentDate,
        currency: paymentScheduleData.currency,
        schedule: paymentScheduleData.payments?.map((item) => ({
          amount: georgianFormatter.format(item.amount),
          name: dayjs(item.details.paymentDate).format('MMM'),
          passed: item.status === 'paid' ? true : false,
          active:
            dayjs(paymentScheduleData.nextPaymentDate).format('MMMM') ===
              dayjs(item.details.paymentDate).format('MMMM') && item.status !== 'paid'
              ? true
              : false,
        })),
      }
      //
      return formatedData
      //
    } else {
      return undefined
    }
  }
  //
  const paymentScheduleArray = _scheduleArray()
  //
  const [openDialogModal, setOpenDialogModal] = useState<boolean>(false)

  const _onCloseDialogMOdal = () => {
    setOpenDialogModal(false)
  }
  //
  //
  const [deletePendingPolicy, { isLoading: isDeletePendingPolicyLoading }] = api.useDeleteUserPendingPolicyMutation()
  //
  const deleteSelectedPendingPolicy = async () => {
    try {
      await deletePendingPolicy(policyIdToNumber).unwrap()
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (deleteSelectedPendingPolicy)')
      }
    }
    window.location.href = '/my-policies'
  }
  //
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false)

  const _onCloseDeleteModal = () => {
    setOpenDeleteModal(false)
  }
  //
  const [createOrder, { data: createPendingNewOrder, isLoading: isCreatePendingNewOrderLoading }] =
    api.useCreateUserPendingNewOrderMutation()

  const paySelectedPendingPolicies = async () => {
    try {
      const response = await createOrder({
        policyIds: [policyIdToNumber],
        targetType: policyDetail?.mainPolicy?.targetType,
      }).unwrap()
      if ('orderItems' in response) {
        setOpenDialogModal(true)
        //
        policyDetailRefetch()
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (102)')
      }
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (110)')
      }
    }
  }
  //
  const companyName = createPendingNewOrder?.orderItems[0]?.company?.[lang]?.title
  const amount = createPendingNewOrder?.orderItems[0]?.totalPrice
  const insuranceType = createPendingNewOrder?.orderItems[0].category?.[lang]?.title
  const paymentScheduleType = paymentMethods?.find(
    (x) => x.id === createPendingNewOrder?.orderItems?.[0]?.paymentScheduleTypeId,
  )?.slug
  const eachPrice = createPendingNewOrder?.orderItems[0]?.eachPrice
  const monthlyPrice = createPendingNewOrder?.orderItems[0]?.monthlyPrice
  const slug = createPendingNewOrder?.orderItems[0]?.slug
  const orderTotalPrice = createPendingNewOrder?.orderItems[0]?.totalPrice
  const currency = createPendingNewOrder?.orderItems[0]?.currency
  const orderSingleInfo = {
    companyName: companyName,
    amount: amount,
    insuranceType: insuranceType,
    paymentScheduleType: paymentScheduleType,
    eachPrice: eachPrice,
    monthlyPrice: monthlyPrice,
    slug: slug,
    totalPrice: orderTotalPrice,
    currency: currency,
  }
  const orderModalInfo = [orderSingleInfo]
  //
  const [openPendingPayments, setOpenPendingPayments] = useState<boolean>(false)

  const orderIdForOrderInfo = createPendingNewOrder?.order?.id
  const totalPrice = createPendingNewOrder?.order?.totalPrice
  const currentPaymentAmount = createPendingNewOrder?.order?.currentPaymentAmount
  const discountUsed = createPendingNewOrder?.order?.discounted
  const validPromoCode = createPendingNewOrder?.order?.validPromoCode

  const orderInfo = {
    orderId: orderIdForOrderInfo,
    totalPrice: totalPrice,
    category: ['pet'],
    paymentScheduleType: paymentScheduleType,
    currentPaymentAmount: currentPaymentAmount,
    discountUsed: discountUsed,
    validPromoCode: validPromoCode,
  }
  //
  const isMainLoading =
    isPolicyDetailLoading ||
    isPaymentScheduleDataLoading ||
    isPaymentTransactionLoading ||
    isCreatePendingNewOrderLoading ||
    isDeletePendingPolicyLoading ||
    isPaymentMethodsLoading
  //
  //
  return isMainLoading ? (
    <Loader />
  ) : !policyDetail ? (
    <NotFound404 />
  ) : openPendingPayments ? (
    <PendingPayments orderInfo={orderInfo} />
  ) : (
    <Wrapper>
      <>
        <MuiBox>
          <TabContext value={activeTab}>
            <BoxStyle>
              <MuiTabList onChange={handleChange} aria-label="lab API tabs example">
                <MuiTab label={t('inDetails')} value="1"></MuiTab>
                <MuiTab label={t('transactions')} value="2" />
              </MuiTabList>
              {policyDetail?.mainPolicy?.status?.toLowerCase() === 'active' ||
              policyDetail?.mainPolicy?.status?.toLowerCase() === 'closed' ? (
                <>
                  {activeTab === '1' ? (
                    <Div>
                      <DownloadButton
                        style={{ marginLeft: 'auto' }}
                        onClick={(event) => downloadPdf(event, policyDetail.mainPolicy.policyPdfUrl)}
                      />
                    </Div>
                  ) : null}
                </>
              ) : (
                <>
                  {activeTab === '1' ? (
                    <Btns>
                      <PayButton
                        text="Pay"
                        onClick={() => {
                          paySelectedPendingPolicies()
                        }}
                      />
                      <TrashButton onClick={() => setOpenDeleteModal(true)} />
                    </Btns>
                  ) : null}
                </>
              )}
            </BoxStyle>

            <MuiTabPanel value="1">
              <div>
                <AccordionWrapper>
                  <Accordion title={t('policyInfo')} openAccordion={true}>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('insuranceCompany')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.package?.product?.company?.translations[lang]?.title}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('category')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.targetType === 'PetPolicy' ? t('petInsurance') : ''}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('policyNumber')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.mainPolicy?.policyNumber}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('startDate')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {dayjs(policyDetail?.mainPolicy?.startDate).format('DD MMMM YYYY')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('endDate')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {dayjs(policyDetail?.mainPolicy?.endDate).format('DD MMMM YYYY')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('numberOfDays')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {diffInDays} {t('day')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('releaseDate')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {dayjs(policyDetail?.mainPolicy?.updatedAt).format('DD MMMM YYYY | HH:mm')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('status')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {lang === 'ge' && policyDetail?.mainPolicy?.status?.toLowerCase() === 'active'
                          ? 'აქტიური'
                          : lang === 'ge' && policyDetail?.mainPolicy?.status?.toLowerCase() === 'pending'
                          ? 'მომლოდინე'
                          : policyDetail?.mainPolicy?.status}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('policePrice')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {discount === null
                          ? `${georgianFormatter.format(policyDetail?.price as unknown as number)} ${currencySymbol(
                              policyDetail?.mainPolicy?.compensationCurrency,
                            )}`
                          : `${georgianFormatter.format(
                              discount?.promoCode?.applyingDiscount?.actualAmount,
                            )}  ${currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}`}{' '}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    {discount !== null && (
                      <>
                        <CheckInfoTextBox>
                          <OffetTextLeftSide>{t('promoCode')}</OffetTextLeftSide>
                          <OffetTextRightSide>{discount?.promoCode?.code}</OffetTextRightSide>
                        </CheckInfoTextBox>
                      </>
                    )}

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('paymentSchedule')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {/* {
                          paymentMethods?.find(
                            (x) =>
                              x.slug?.toLowerCase() ===
                              policyDetail?.mainPolicy?.orderItems?.[0]?.paymentScheduleType?.slug?.toLowerCase(),
                          )?.translations?.[lang]?.title
                        } */}
                        {policyDetail?.mainPolicy?.orderItems?.[0]?.paymentScheduleType?.translations?.[lang]?.title}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('fistPayment')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {georgianFormatter.format(paymentScheduleData?.payments?.[0]?.amount as number)}{' '}
                        {currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    {policyDetail?.mainPolicy?.orderItems?.[0]?.paymentScheduleType?.slug?.toLowerCase() ===
                    'one-time' ? null : (
                      <CheckInfoTextBox>
                        <OffetTextLeftSide>{t('eachPayment')}</OffetTextLeftSide>
                        <OffetTextRightSide>
                          {georgianFormatter.format((paymentScheduleData?.payments || []).slice(-1)[0]?.amount)}{' '}
                          {currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}
                        </OffetTextRightSide>
                      </CheckInfoTextBox>
                    )}
                  </Accordion>

                  <Accordion title={t('petInformation')} openAccordion={false}>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('category')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.animalCategory?.translations[lang]?.name}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('firstName')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.petInformation?.name}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('age')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.petInformation?.age?.year >= 1 && policyDetail?.petInformation?.age?.month === 0
                          ? policyDetail?.petInformation?.age?.year + ' ' + t('year')
                          : policyDetail?.petInformation?.age?.month >= 1 &&
                            policyDetail?.petInformation?.age?.year === 0
                          ? policyDetail?.petInformation?.age?.month + ' ' + t('month')
                          : policyDetail?.petInformation?.age?.year >= 1 &&
                            policyDetail?.petInformation?.age?.month >= 1
                          ? policyDetail?.petInformation?.age?.year +
                            ' ' +
                            t('year') +
                            ', ' +
                            policyDetail?.petInformation?.age?.month +
                            ' ' +
                            t('month')
                          : null}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('breed')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.breed?.translations[lang]?.name}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('color')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.petInformation?.color}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('gender')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.petInformation?.gender === 'female' ? t('petFemale') : t('petMale')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>
                  </Accordion>

                  {policyDetail?.mainPolicy?.package?.target &&
                  policyDetail.mainPolicy?.package?.target?.petCoverages?.length < 1 ? null : (
                    <Accordion title={t('whatIsCovered')} openAccordion={false}>
                      <NotCoveredDiv>
                        {policyDetail.mainPolicy?.package?.target?.petCoverages?.map((item: any, index: number) => (
                          <CheckInfoTextBox key={index}>
                            <OffetTextLeftSide>{item.translations?.[lang]?.title}</OffetTextLeftSide>
                            <OffetTextRightSide>{item.translations?.[lang]?.body}</OffetTextRightSide>
                          </CheckInfoTextBox>
                        ))}
                      </NotCoveredDiv>
                    </Accordion>
                  )}

                  {policyDetail.mainPolicy?.package?.target &&
                  policyDetail.mainPolicy?.package?.target?.petImportantTerms?.length < 1 ? null : (
                    <Accordion title={t('notCovered')} openAccordion={false}>
                      <InsuranceExceptionsBlock>
                        {policyDetail.mainPolicy?.package?.target?.petImportantTerms?.map(
                          (item: any, index: number) => (
                            <MessageText key={index}>
                              <DoubleRightIcon /> <span>{item?.translations?.[lang]?.body}</span>
                            </MessageText>
                          ),
                        )}
                      </InsuranceExceptionsBlock>
                    </Accordion>
                  )}

                  <Accordion title={t('documents')} openAccordion={false}>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('insuranceContract')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        <CustomATag
                          href={policyDetail?.mainPolicy?.package?.wordingFiles?.translations?.[lang]?.url}
                          target={'_blank'}
                        >
                          {policyDetail?.mainPolicy?.package?.wordingFiles?.translations?.[lang]?.url}
                        </CustomATag>
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('policyContract')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        <CustomATag href={policyDetail?.mainPolicy?.policyPdfUrl} target={'_blank'}>
                          {policyDetail?.mainPolicy?.policyPdfUrl}
                        </CustomATag>
                      </OffetTextRightSide>
                    </CheckInfoTextBox>
                  </Accordion>
                </AccordionWrapper>
                {
                  <PendingPayModal
                    onClick={() => setOpenPendingPayments(true)}
                    onClose={_onCloseDialogMOdal}
                    isOpen={openDialogModal}
                    orderModalInfo={orderModalInfo}
                    orderInfo={orderInfo}
                  >
                    {t('paymentDetails')}
                  </PendingPayModal>
                }
                {
                  <DeleteModal onClose={_onCloseDeleteModal} isOpen={openDeleteModal}>
                    <ModalItems>
                      <FailIcon />
                      <ModalText>{t('areYouSureYouWantToDelete')}</ModalText>
                      <Button onClick={deleteSelectedPendingPolicy} text={t('yesDelete')} fullWidth />
                      <Button
                        onClick={_onCloseDeleteModal}
                        text={t('cancel')}
                        buttonType="transparent"
                        style={{ border: 'none', marginTop: '10px' }}
                        fullWidth
                      />
                    </ModalItems>
                  </DeleteModal>
                }
              </div>
            </MuiTabPanel>
            {/*  */}
            {/*  */}
            {/*  */}
            <MuiTabPanel value="2">
              {policyDetail?.mainPolicy?.orderItems?.[0]?.paymentScheduleType?.slug?.toLowerCase() ===
              'one-time' ? null : (
                <>
                  <PaymentSchedule scheduleData={paymentScheduleArray} />
                  <br />
                  <br />
                </>
              )}

              <TransactionTitle>{t('transactionHistory')}</TransactionTitle>
              <TransactionsStyle>
                <TitleSection>
                  <Title></Title>
                  <Title>{t('company')}</Title>
                  <Title>{t('policy')}#</Title>
                  <Title>{t('date')}</Title>
                  <Title>{t('value')}</Title>
                  <TitleHideInMobile>{t('status')}</TitleHideInMobile>
                </TitleSection>
                {paymentTransactions?.map((item, index) => (
                  <ContentStyles key={index}>
                    <Title>
                      <PetIconStyle />
                    </Title>
                    <Title>{item?.companyTranslations[lang]?.title}</Title>
                    <Title>{item?.policyNumber}</Title>
                    <Title>{dayjs(item.transferDate).format('DD.MM.YYYY')}</Title>
                    <Title>{georgianFormatter.format(item.transferAmount as number)}</Title>
                    <TitleHideInMobile>
                      <StatusSpan>
                        {item.status}
                        {item.status && (
                          <StatusBall
                            style={{
                              backgroundColor:
                                item.status === 'paid'
                                  ? Colors.java
                                  : item.status === 'pending'
                                  ? Colors.Primary
                                  : Colors.primaryRed,
                            }}
                          />
                        )}
                      </StatusSpan>
                    </TitleHideInMobile>
                  </ContentStyles>
                ))}
                <br />
                {paymentTransactions?.map((item, index) => (
                  <ContentStylesMobile key={index}>
                    <div>
                      <Title>
                        <PetSmallIconStyle />
                        {item.carRegistrationNumber}
                      </Title>
                      <Title>
                        <StatusSpan>
                          {item.status && (
                            <StatusBall
                              style={{
                                backgroundColor:
                                  item.status === 'paid'
                                    ? Colors.java
                                    : item.status === 'pending'
                                    ? Colors.Primary
                                    : Colors.primaryRed,
                              }}
                            />
                          )}
                        </StatusSpan>
                      </Title>
                    </div>
                    <div>
                      <Title>{t('policy')}#:</Title>
                      <Title>{item.policyNumber}</Title>
                    </div>
                    <div>
                      <Title>{t('date')}:</Title>
                      <Title>{dayjs(item.transferDate).format('DD.MM.YYYY')}</Title>
                    </div>
                    <div>
                      <Title>{t('value')}:</Title>
                      <Title>
                        {georgianFormatter.format(item.transferAmount as number) +
                          currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}
                      </Title>
                    </div>
                  </ContentStylesMobile>
                ))}
              </TransactionsStyle>
            </MuiTabPanel>
          </TabContext>
        </MuiBox>
      </>
    </Wrapper>
  )
}
//
//
const Btns = styled.div`
  display: flex;
  margin-left: auto;
  ${Responsive.mobile} {
    margin-block: 24px;
  }
`
const ModalItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 50px 30px;
  ${Responsive.mobile} {
    padding: 0px;
  }
`
const ModalText = styled.div`
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
const InsuranceExceptionsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0px;
  }

  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }

  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }

  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }

    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const TransactionTitle = styled.h3`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 35px;
`
const StatusBall = styled.span`
  height: 7px;
  width: 7px;
  border-radius: 50px;
  background-color: ${Colors.primaryGreen};
  user-select: none;
  pointer-events: none;
  padding: 0px !important;
  position: absolute;
  margin-left: 5px;
  margin-top: 7px;
  ${Responsive.mobile} {
    margin-top: 6px;
  }
  ${Responsive.mobile} {
    margin-top: 0px;
  }
`
const StatusSpan = styled.span`
  ${Responsive.mobile} {
    margin-left: -13px;
    position: relative;
  }
`
const PetSmallIconStyle = styled(PetSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const PetIconStyle = styled(PetIcon)`
  margin-top: -15px;
`
const ContentStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  padding-top: 40px;
  margin-top: 40px;
  box-shadow: 160px -2px 0px ${Colors.grey};
  :nth-child(1) {
    box-shadow: none;
  }
  &:nth-child(2) {
    padding-top: 20px;
    margin-top: 0px;
    border-top: 0px;
    box-shadow: none;
  }
  div {
    text-align: left;
    :first-child {
      text-align: center;
    }
    :nth-child(8) {
      text-align: center;
    }
  }
  /*  */
  ${Responsive.laptop} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
`
const TitleSection = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  margin-bottom: 40px;
  div {
    color: ${Colors.primaryGrey};
    text-align: left;
    :nth-child(8) {
      text-align: center;
    }
  }
  /*  */
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    margin-bottom: 10px;
  }
`
const Title = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  user-select: none;
  /* background-color: red; */
  /* responsive */
  ${Responsive.laptop} {
    font-size: 12px;
  }
  ${Responsive.tablet} {
    font-size: 12px;
    padding-left: 0px;
  }

  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }
`
const TitleHideInMobile = styled(Title)`
  ${Responsive.mobile} {
    display: none;
  }
`
const ContentStylesMobile = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
`
const TransactionsStyle = styled.div`
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  background-color: ${Colors.white};
  border-radius: 8px;
  overflow: hidden;
  &:first-child {
    margin-bottom: 55px;
  }
  ${Responsive.mobile} {
    padding-inline: 24px;
    &:first-child {
      margin-bottom: 26px;
    }
  }
`
const Div = styled.div`
  display: block;
  margin-left: auto;
  cursor: pointer;
  ${Responsive.mobile} {
    display: flex;
    margin-block: 24px;
  }
`
const CustomATag = styled.a`
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration-color: ${Colors.primaryRed};
  color: ${Colors.primaryBlack};
  &:hover {
    color: ${Colors.primaryBlack};
    opacity: 0.9;
  }
`
const MuiTabList = styled(TabList)`
  button {
    padding: 0px;
    margin-right: 60px;
    font-size: 18px;
    text-transform: none;

    &:last-child {
      margin-right: 0px;
    }
  }

  .MuiTabs-indicator {
    background-color: ${Colors.primaryBlack} !important;
  }

  .MuiTouchRipple-root {
    display: none !important;
  }
  ${Responsive.mobile} {
    button {
      margin-right: auto;
      font-size: 13px;
    }
  }
`
const MuiTab = styled(Tab)`
  color: ${Colors.primaryBlack} !important;
`
const MuiTabPanel = styled(TabPanel)`
  padding: 0px !important;
  margin-top: 45px;
  ${Responsive.mobile} {
    margin-top: 20px;
  }
`
const MuiBox = styled(Box)``
const BoxStyle = styled(Box)`
  display: flex;
  ${Responsive.mobile} {
    display: block;
  }
`
const Wrapper = styled.div`
  height: 100%;
  .MuiButtonBase-root {
    font-family: inherit;
  }
`

const AccordionWrapper = styled.div``
const CheckInfoTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0px;
  }
  ${Responsive.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`
const OffetTextLeftSide = styled.span`
  color: ${Colors.primaryGrey};
  font-size: 14px;
`
const OffetTextRightSide = styled.span`
  color: ${Colors.primaryBlack};
  font-size: 14px;
`

const NotCoveredDiv = styled.div`
  ${OffetTextRightSide} {
    text-align: right;
    flex-basis: 60%;
  }

  ${Responsive.mobile} {
    ${OffetTextRightSide} {
      text-align: left;
      flex-basis: unset;
    }
  }
`

export default PetPolicyDetail
